import { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextField from "@mui/material/TextField";
import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
import durationPlugin from 'dayjs/plugin/duration';

import styles from '../../../../styles/case/time_filter/TimeFilter.module.scss';

dayjs.extend(utcPlugin);
dayjs.extend(durationPlugin);

/**
 * @param {Date} props.from
 * @param {function} props.setFrom
 * @param {Date} props.to
* @param {function} props.setTo
 */
function TimeFilter(props) {
  const sx = {
    // 'label, input, div, filedset, span, legend, button, svg': {
    //   color: '#F3F6F7',
    //   borderColor: '#F3F6F7'
    // }
  };
  const [crtFrom, setCrtFrom] = useState(0);
  const [crtTo, setCrtTo] = useState(0);

  function apply() {
    props.setValue(v => ({ ...v, from: crtFrom || v.from, to: crtTo || v.to }));
  }

  useEffect(() => {
    setCrtFrom(dayjs.utc(props.value?.from || 0).valueOf());
    setCrtTo(dayjs.utc(props.value?.to || 0).valueOf());
  }, [props.value])
  if (crtFrom === 0 || crtTo === 0) return <></>

  return (
    <div className={styles.timeFilter}>
      <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs.utc}>
        <DateTimePicker
          label='From (GMT)'
          value={dayjs.utc(crtFrom)}
          onChange={newFrom => setCrtFrom(newFrom.valueOf())}
          views={['year', 'month', 'day', 'hours', 'minutes']}
          format='YYYY-MM-DD HH:mm'
          sx={sx}
        />
        <DateTimePicker
          label='To (GMT)'
          value={dayjs.utc(crtTo)}
          onChange={newTo => setCrtTo(newTo.valueOf())}
          views={['year', 'month', 'day', 'hours', 'minutes']}
          format='YYYY-MM-DD HH:mm'
          sx={sx}
        />
        <button className={styles.actionButton} onClick={apply}>Apply</button>
      </LocalizationProvider>
    </div>
  );
}

export default TimeFilter;